import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage,
  LifeSaverForm,
  ScreenHeader, TextArea
} from '../../components';
import { useCreateOrUpdate, useFormData } from '../../hooks';

import { NewFAContext } from '.';

const formConfig = {
  fields: [
    { 
      id: 'donation-details', 
      fieldName: 'donation_details',
      type: 'text' as const,
      required: true 
    }
  ]
};


export function NewFADonationArrangements() {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleCreateOrUpdate } = useCreateOrUpdate('funeral_arrangements');
  const { handleData, errors } = useFormData(formConfig);
    
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const formData = handleData();
    
    // Validate required fields
    if (!formData.donation_details) {
      return;
    }

    const payload = {
      ...formData,
      user_id: funeralArrangement?.user_id || null,
      person_id: funeralArrangement?.person_id || null
    };

    try {
      await handleCreateOrUpdate(funeralArrangement?.id || '', payload);
      await update();
      navigate('../ceremony-preferences');
    } catch (err) {
      console.error('Error saving donation arrangements:', err);
    }
  }, [ navigate, funeralArrangement, handleCreateOrUpdate, update, handleData ]);

  return (
    <div className="new-fa-disposition screen">
      <ScreenHeader 
        title="Donation Arrangements"
        description="Specify your donation preferences and arrangements."
        steps={6}
        step={1}
        handleBack={handleBack}
      />

      <LifeSaverForm 
        icon="location_on"
        header="Details of Donation"
      >
        <TextArea
          id="donation-details"
          name="donation_details"
          label="Donation Details"
          placeholder="Enter details about your body donation preferences..."
          style={{ maxWidth: '100%' }}
          required
        />
      </LifeSaverForm>

      <ErrorMessage message={errors[0]} />
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}